import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { consultarMultas, getJurisdicciones } from '../../services/api';
import SearchForm from '../../components/SearchForm';
import ResultadosCard from '../../components/ResultadosCard';
import Loader from '../../components/Loader';
import './ConsultaMultasPanel.css';

const ConsultaMultasPanel = () => {
  const [patente, setPatente] = useState('');
  const [jurisdicciones, setJurisdicciones] = useState([]);
  const [selectedJurisdicciones, setSelectedJurisdicciones] = useState([]);
  const [resultados, setResultados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadJurisdicciones();
  }, []);

  const loadJurisdicciones = async () => {
    try {
      const data = await getJurisdicciones();
      setJurisdicciones(data);
    } catch (err) {
      console.error('Error cargando jurisdicciones:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!patente.trim()) {
      setError('Por favor ingrese una patente');
      return;
    }

    setLoading(true);
    setError(null);
    setResultados(null);

    try {
      const data = await consultarMultas(
        patente,
        selectedJurisdicciones.length > 0 ? selectedJurisdicciones : null
      );
      setResultados(data);
    } catch (err) {
      console.error('Error completo:', err);

      let errorMessage = 'Error al consultar multas';

      if (err.response) {
        const errorData = err.response.data;

        if (err.response.status === 422 && errorData.detail) {
          if (Array.isArray(errorData.detail)) {
            errorMessage = errorData.detail
              .map(e => `${e.loc.join('.')}: ${e.msg}`)
              .join(', ');
          } else if (typeof errorData.detail === 'string') {
            errorMessage = errorData.detail;
          } else {
            errorMessage = JSON.stringify(errorData.detail);
          }
        } else if (typeof errorData.detail === 'string') {
          errorMessage = errorData.detail;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } else if (err.request) {
        errorMessage = 'No se pudo conectar con el servidor';
      } else {
        errorMessage = err.message || 'Error desconocido';
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const toggleJurisdiccion = (codigo) => {
    setSelectedJurisdicciones(prev => {
      if (prev.includes(codigo)) {
        return prev.filter(j => j !== codigo);
      } else {
        return [...prev, codigo];
      }
    });
  };

  return (
    <div className="consulta-multas-panel">
      <h1 className="panel-page-title">
        <FontAwesomeIcon icon={faCar} /> Consulta de Multas
      </h1>

      <SearchForm
        patente={patente}
        setPatente={setPatente}
        jurisdicciones={jurisdicciones}
        selectedJurisdicciones={selectedJurisdicciones}
        toggleJurisdiccion={toggleJurisdiccion}
        onSubmit={handleSubmit}
        loading={loading}
      />

      {error && (
        <div className="panel-error-message">
          <FontAwesomeIcon icon={faExclamationTriangle} /> {error}
        </div>
      )}

      {loading && <Loader />}

      {resultados && !loading && (
        <ResultadosCard resultados={resultados} />
      )}
    </div>
  );
};

export default ConsultaMultasPanel;
